import { Component, inject, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';

import { InvestigatorTransactionSupportingSectionComponent } from '../investigator-transaction-supporting-section/investigator-transaction-supporting-section.component';

@Component({
  imports: [InvestigatorTransactionSupportingSectionComponent],
  templateUrl: './remove-transaction-modal.component.html',
})
export class RemoveTransactionModalComponent {
  ref = inject(CustomOverlayRef<unknown, { createMode: boolean }>);

  noteFormControl = new FormControl('', [Validators.required]);
  @ViewChild('supportingSection')
  supportingSection?: InvestigatorTransactionSupportingSectionComponent;

  deleteTransaction = async () => {
    if (this.noteFormControl.invalid && !this.ref.data?.createMode) {
      return;
    }

    if (this.ref.data?.createMode) {
      this.ref.close({ remove: true });
    }

    const { documents, note } = (await this.supportingSection?.saveSupportingSection()) || {};

    this.ref.close({ documents, note, remove: true });
  };
}
